import { ReactElement, FC, memo } from 'react'

import { ASSETS } from '../../../constants'
import { useI18n } from '../../../hooks'
import Image from '../../atoms/images/image'
import AboutGlobe from '../aboutGlobe'

const COUNTRIES_NUMBER = 180

const Countries: FC = (): ReactElement => {
  const ua = navigator.userAgent
  const isIE = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1
  const { t } = useI18n()
  return (
    <div className="about-countries">
      <div className="about-countries-info">
        <h1 className="heavy">{COUNTRIES_NUMBER}+</h1>
        <p>{t('About_countriesServed')}</p>
      </div>
      <div className="about-countries-earth">
        {!isIE ? (
          <AboutGlobe />
        ) : (
          <Image
            className="about-countries-globe-image"
            src={`${ASSETS}/pages/about/globe.svg`}
            alt="about page globe image"
            size={{ width: '60%', height: 'auto' }}
          />
        )}
      </div>
    </div>
  )
}

export default memo(Countries)
